import { motion } from "framer-motion";
import Field from "@/components/booking/Field";
import DateTimeFields from "@/components/booking/DateTimeFields";
import TermsCheckbox from "@/components/booking/TermsCheckbox";
import { STEP_MOTION } from "@/lib/motion-presets";

export default function BookingStep3({ t, form, set, errors, minDate }) {
  return (
    <motion.div key="s3" {...STEP_MOTION} className="space-y-5">
      <DateTimeFields t={t} form={form} set={set} errors={errors} minDate={minDate} />
      <Field label={t.booking.fields.notes}>
        <textarea
          data-testid="booking-notes-input"
          className="input-field"
          value={form.notes}
          onChange={(e) => set("notes", e.target.value)}
          placeholder={t.booking.fields.notesPh}
        />
      </Field>
      <div>
        <label
          className={`flex items-start gap-3 p-4 rounded-xl border-2 cursor-pointer transition-colors ${
            errors.notice_accepted
              ? "border-[var(--accent)] bg-[var(--accent)]/5"
              : "border-amber-300 bg-amber-50"
          }`}
        >
          <input
            type="checkbox"
            checked={form.notice_accepted}
            onChange={(e) => set("notice_accepted", e.target.checked)}
            className="mt-0.5 w-5 h-5 shrink-0 accent-[var(--secondary)]"
            data-testid="booking-consent-checkbox"
          />
          <span className="text-sm text-slate-700 leading-relaxed">
            {t.booking.consentLabel}
          </span>
        </label>
        {errors.notice_accepted && (
          <p
            className="text-xs font-semibold text-[var(--accent)] mt-1.5"
            data-testid="booking-consent-error"
          >
            {errors.notice_accepted}
          </p>
        )}
      </div>
      <TermsCheckbox t={t} form={form} set={set} errors={errors} />
    </motion.div>
  );
}
